// Mensagens contextuais por scope de loading.
// Cada lista é rotacionada a cada ~2s para dar ao usuário a sensação de
// progresso ativo (waiting UX). Mantenha mensagens curtas (≤ 32 chars).

export const MESSAGES = {
  auth: [
    "Verificando seu acesso...",
    "Carregando seu perfil...",
    "Conectando ao sistema...",
  ],
  bootDados: [
    "Conectando ao sistema...",
    "Lendo a planilha gerencial...",
    "Sincronizando ambientes...",
    "Calculando produção...",
    "Quase lá...",
  ],
  home: [
    "Calculando produção...",
    "Detectando gargalo do dia...",
    "Medindo throughput...",
    "Carregando atalhos...",
  ],
  clientes: [
    "Buscando clientes...",
    "Organizando pedidos...",
    "Carregando portfólio...",
    "Calculando saúde...",
  ],
  terceiros: [
    "Listando itens pendentes...",
    "Conferindo fornecedores...",
    "Calculando atrasos...",
  ],
  entregas: [
    "Calendarizando entregas...",
    "Verificando prazos...",
    "Montando rota...",
  ],
  kpis: [
    "Detectando gargalo...",
    "Calculando buffers...",
    "Medindo throughput...",
    "Carregando histórico...",
  ],
  kpisTempos: [
    "Cronometrando etapas...",
    "Calculando lead times...",
    "Levantando médias...",
  ],
  marcenaria: [
    "Listando bancadas...",
    "Calculando carga...",
    "Buscando marceneiros...",
  ],
  marceneiros: [
    "Listando marceneiros...",
    "Calculando produtividade...",
  ],
  industrializacao: [
    "Ligando as máquinas...",
    "Calculando fila...",
    "Carregando bordeiras...",
  ],
  compras: [
    "Conferindo lotes...",
    "Buscando chapas...",
    "Carregando insumos...",
  ],
  ferragens: [
    "Conferindo ferragens...",
    "Buscando insumos...",
    "Listando pendências...",
  ],
  acabamento: [
    "Misturando tintas...",
    "Listando ambientes em acabamento...",
    "Calculando prazos...",
  ],
  acabamentos: [
    "Conferindo definições...",
    "Buscando ambientes em definição...",
    "Listando pendências...",
  ],
  liberacao: [
    "Verificando obras...",
    "Conferindo bloqueios...",
    "Listando ambientes...",
  ],
  ppcp: [
    "Otimizando lotes...",
    "Listando ambientes aprovados...",
    "Calculando programação...",
  ],
  executivo: [
    "Carregando projetos...",
    "Listando ambientes em desenho...",
  ],
  aprovacao: [
    "Listando executivos prontos...",
    "Verificando assinaturas...",
  ],
  medicao: [
    "Listando obras liberadas...",
    "Conferindo medições...",
  ],
  revisao: [
    "Listando revisões...",
    "Conferindo aprovações...",
  ],
  obras: [
    "Listando entregas concluídas...",
    "Conferindo histórico...",
  ],
  financeiro: [
    "Calculando receita...",
    "Listando ABC...",
    "Conferindo atrasos...",
  ],
  acessos: [
    "Listando usuários...",
    "Conferindo permissões...",
  ],
  default: [
    "Carregando dados...",
    "Quase lá...",
    "Conectando ao sistema...",
  ],
};

export function getMessages(scope) {
  if (!scope) return MESSAGES.default;
  return MESSAGES[scope] || MESSAGES.default;
}
